import classNames from 'classnames'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { useContentOverflow } from '../../../../hooks'
import { FloatingTooltip } from '../../../Floating'
import { Headline2 } from '../../../Headline2'
import { Skeleton } from '../../../Skeleton'
import { EntityArchivedIcon } from '../../EntityArchivedIcon'

import * as styles from '../EntityProfileHeaderText.module.css'

function EntityProfileHeaderTextBase({
  clampLines,
  className = styles.EntityProfileHeaderTextWrapper,
  isArchived,
  isLoading,
  isOpen,
  text,
  textClassName,
  textPlaceholder,
  textRef,
}) {
  const isClamped = clampLines && isOpen

  const { overflow, setContentOverflowRef } = useContentOverflow({
    dep: [text, textPlaceholder, isOpen],
    externalRef: textRef,
  })

  const archivedIcon = isArchived ? (
    <EntityArchivedIcon containerClassName={styles.archivedIconContainer} />
  ) : null

  return (
    <FloatingTooltip
      content={text}
      disabled={!text || !overflow}
      placement={FLOATING_ELEMENT_PLACEMENT.top}
    >
      <div
        className={className}
        style={
          isClamped
            ? { '--entity-profile-header-text-clamp-lines': clampLines }
            : undefined
        }
      >
        {isLoading ? (
          <Skeleton className={styles.skeleton} />
        ) : (
          <>
            <Headline2
              className={classNames(
                styles.text,
                {
                  [styles.clamped]: isClamped,
                  [styles.textNowrap]: !isOpen,
                },
                textClassName
              )}
              isSecondary={!text && textPlaceholder}
              ref={setContentOverflowRef}
            >
              {text || textPlaceholder}
              {isClamped ? null : archivedIcon}
            </Headline2>
            {isClamped ? archivedIcon : null}
          </>
        )}
      </div>
    </FloatingTooltip>
  )
}

export default EntityProfileHeaderTextBase
